import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import VideoSubmissionSection from '../components/VideoSubmissionSection';
import * as Yup from 'yup';
import axios from 'axios';
import './LoginPage.css';
import routes from '../api_routes';

const LoginSchema = Yup.object().shape({
  username: Yup.string().required('Username is required'),
  password: Yup.string().required('Password is required'),
});

function LoginPage() {
  const [loginError, setLoginError] = useState('');
  const [submissionsError, setSubmissionsError] = useState('');
  const [submissionId, setSubmissionId] = useState('');
  const [creatorId, setCreatorId] = useState('');
  const [collapsibleStates, setCollapsibleStates] = useState(['CollapsibleContent', 'CollapsibleContent']);
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoginError("");
    try {
      const response = await axios.post(routes.auth, values);
      const { access_token } = response.data;

      // Store the token securely (preferably in HttpOnly cookies in real production apps)
      localStorage.setItem('token', access_token);

      // Navigate to upload page
      navigate('/upload');
    } catch (error) {
      setLoginError('Login failed. Please check your credentials.');
    }
  };

  const handleSubmissionAuth = async() => {
    setSubmissionsError("");

    if(submissionId.length < 1) {
      setSubmissionsError("Please provide your submission key");
      return;
    }

    try {
      const response = await axios.post(`${routes.auth}/submission`, {'submission_key': submissionId});
      const { channel_id, access_token } = response.data;
      localStorage.setItem('submission_token', access_token);
      setCreatorId(channel_id);
    }
    catch(error) {
      setSubmissionsError("Submission authentication failed.");
    }
  };

  const toggleCollapsible = (ind) => {
    if(collapsibleStates[ind] === "") {
      let newCol = [...collapsibleStates];
      newCol[ind] = "CollapsibleContent";
      setCollapsibleStates(newCol);
    }
    else {
      let newCol = [...collapsibleStates];
      newCol[ind] = "";
      setCollapsibleStates(newCol);
    }
  }

  return (
    <div className="LoginArea">
      <img src="/hearthfire-logo.png" alt="Hearthfire Radio" className="LogoImage"></img>

      <button onClick={() => toggleCollapsible(0)} className="Collapsible"><h3>{collapsibleStates[0].length>0?'＋':'－'} Creator Submissions</h3></button>
      <div className={collapsibleStates[0]}>
        
        <p className="LoginError">{submissionsError}</p>
        <span>
          <label htmlFor="creatorIdField">Submitter ID:</label>
          <input name="creatorIdField" id="submission-creator-id" type="text" onChange={(e) => setSubmissionId(e.target.value)}></input>
          <button className="StandardButton" onClick={handleSubmissionAuth}>Verify</button>
        </span>
        { creatorId && creatorId.length > 0 && <div>
          <VideoSubmissionSection channelId={creatorId}></VideoSubmissionSection>
        </div>}
      </div>
  
      <button onClick={() => toggleCollapsible(1)} className="Collapsible"><h3>{collapsibleStates[1].length>0?'＋':'－'} Admin Portal</h3></button>
      <div className={collapsibleStates[1]}>
        <p className="LoginError">{loginError}</p>
        <Formik
          initialValues={{ username: '', password: '' }}
          validationSchema={LoginSchema}
          onSubmit={handleLogin}
        >
          {({ errors, touched }) => (
            <Form className="LoginForm">
              <div className="LoginField">
                <div className="LoginLabelPair">
                  <label>Username:</label>
                  <Field name="username" />
                </div>
                {errors.username && touched.username && <div className="LoginError">{errors.username}</div>}
              </div>
              <div className="LoginField">
                <div className="LoginLabelPair">
                  <label>Password:</label>
                  <Field name="password" type="password" />
                </div>
                {errors.password && touched.password && <div className="LoginError">{errors.password}</div>}
              </div>
              <div className="ButtonBreak"></div>
              <button type="submit" className="StandardButton">Login</button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default LoginPage;